import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://quizzler-production.up.railway.app';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('quizzler_host_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authAPI = {
  login: (email, password) => api.post('/api/auth/login', { email, password }),
  signup: (email, password, name) => api.post('/api/auth/signup', { email, password, name }),
  getMe: () => api.get('/api/auth/me'),
};

// Venues API
export const venuesAPI = {
  getAll: () => api.get('/api/venues'),
  getOne: (venueId) => api.get(`/api/venues/${venueId}`),
  create: (data) => api.post('/api/venues', data),
  update: (venueId, data) => api.put(`/api/venues/${venueId}`, data),
  delete: (venueId) => api.delete(`/api/venues/${venueId}`),
  getLeaderboard: (venueId) => api.get(`/api/venues/${venueId}/leaderboard`),
  getHistory: (venueId) => api.get(`/api/venues/${venueId}/history`),
};

// Game Templates API
export const templatesAPI = {
  getAll: () => api.get('/api/game-templates'),
  getOne: (templateId) => api.get(`/api/game-templates/${templateId}`),
  checkUsage: (venueId, templateId) => api.get(`/api/venues/${venueId}/templates/${templateId}/usage`),
};

// Game History API
export const historyAPI = {
  getAll: (limit = 50, offset = 0) => api.get(`/api/game-history?limit=${limit}&offset=${offset}`),
};

// Subscription API
export const subscriptionAPI = {
  getTiers: () => api.get('/api/hosts/available-tiers'),
getCurrent: () => api.get('/api/hosts/subscription'),
canCreateGame: () => api.get('/api/subscription/can-create-game'),
};

export default api;
